(function ($, Drupal) {
  Drupal.behaviors.arctic_drodown = {
    attach: function (context, settings) {
      var listView = Drupal.t('List View');
      var gridView = Drupal.t('Grid View');
      if ($(window).width() < 992) {
        listView = Drupal.t('List');
        gridView = Drupal.t('Grid');
      }
      var gridIdentifier = settings.path.currentPath;
      var viewFormat = drupalSettings.viewFormat;
      if(viewFormat !== undefined) {
        gridIdentifier = viewFormat.gridIdentifier;
      }
      /* Toggle View and set LocalStorage Key */
      $(".toggle_over_view", context).on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (
          $("body").hasClass("page-view-stories-overview-page") &&
          viewFormat === undefined
        ) {
          gridIdentifier = "stories";
        }
        const isList = $(".arctic_over_view_toggle").hasClass(
          "arctic_list_view"
        );
        const viewClass = isList ? "arctic_list_view" : "arctic_grid_view";
        const viewConfig = isList ? listView : gridView;
        gridViewDisplayChange(viewClass, viewConfig);
        localStorage.setItem(gridIdentifier, viewClass);
        return isList;
      });
      
      $(document).ready(function () {

        if($("body").hasClass("page-view-stories-overview-page") && viewFormat === undefined) {
          gridIdentifier = 'stories';
        }
        if(!$('.arctic_over_view_toggle' ).hasClass("view-news-room")) {
          /* Check LocalStorage for Existing Key and set View */
          if (localStorage.getItem(gridIdentifier) == "arctic_list_view") {
            gridViewDisplayChange('arctic_list_view' , listView);
          } else if (localStorage.getItem(gridIdentifier) == "arctic_grid_view"){
            gridViewDisplayChange('arctic_grid_view' , gridView);
          }else if (viewFormat !== undefined){
            gridViewDisplayChange( viewFormat.format , (viewFormat.format == 'arctic_list_view') ? listView : gridView);
          }
        }

      });
      
      function gridViewDisplayChange(displayType = '', gridText = '') {
        $( '.toggle_text' ).text(gridText);
        if(displayType == 'arctic_list_view') {
          $('.arctic_over_view_toggle, .toggle_icon').addClass('arctic_grid_view');
          $('.arctic_over_view_toggle, .toggle_icon').removeClass('arctic_list_view');
        }
        else {
          $('.arctic_over_view_toggle, .toggle_icon').removeClass('arctic_grid_view');
          $('.arctic_over_view_toggle, .toggle_icon').addClass('arctic_list_view');
        }
      }
    }
  };
})(jQuery, Drupal);
